import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CompanyProfile, CompanyPersonality } from 'Types/CompaniesTypes';
import { usePrevious } from 'Utils/hooks/usePrevious';
import CompanyFollowUnFollowButton from 'Components/common/components/CompanyFollowUnfollowButton';
import {
  IsMobile, companyColorParser, isAPrivateCompany, getCurrentTime, valueToObject
} from 'Utils/UtilityFunctions';
import { Executive } from 'Types/PersonTypes';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Tooltip } from 'antd';
import CompanyWidgetWithHolo from 'Components/common/components/CompanyWidgetWithHolo';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { actions as flurryActions } from 'Slice/HelperSlice';
import DrawerPeopleMoveReason from 'Components/people/components/DrawerPeopleMoveReason';
import { INDUSTRY_NEWS_ROUTE, PERSONALITY_INSIGHTS_ROUTE, translateSkipAreas } from 'Utils/Constants';
import {
  primaryHeadingColor, primaryColor, wLight,
  wMedium, secondaryFont,
  primaryFont, wMBold, maxWidth, retina, minWidthApp, maxTablet,
} from '../../../Utils/utilsStyle';
import TwitterIcon from '../../common/assets/svgIcons/TwitterIcon';
import LinkedInIcon from '../../common/assets/svgIcons/LinkedInIcon';

type PropFeildState = {
  companyName: string,
  linkedinLink?: string,
  twitterLink?: string,
  year: string,
  ceo: Executive | null,
  industry: string,
  count: number,
  logo: string,
  persona: CompanyPersonality[],
  industryId: number,
  websiteLink: string,
  exchange: string,
  companyFiscalYear: string,
};

type Props = {
  companyProfile?: CompanyProfile
  isCluster?: boolean
  companyIndex?: number
  totalCompanies?: number
} & typeof defaultProps;

const defaultProps = {
  companyProfile: { companyId: 0 },
  isCluster: false,
  companyIndex: 0,
  totalCompanies: 0,
};

const Wrapper = styled.div`
 position: relative;
 padding: 50px 30px 0px 30px;
 margin-top: 20px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    padding: 33px 30px 0px 30px;
  }
 &:after{
    content:"";
    width:1px;
    height: 92%;
    position: absolute;
    right:0px;
    top:0px ;
    background-color:#F5F1EA;
  }
  .company-card-counter {
    position: absolute;
    top: 30px;
    left: 35px;
    color: ${primaryHeadingColor};
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: ${wMedium};
    line-height: normal;
    letter-spacing: -0.2px;
  }
  .social-icons-wrap {
    &.privateCompanySocials {
      top: 36px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        top: 14px;
      }
      @media all and (max-width: ${maxTablet}) {
        top: 13px;
      }
    }
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      position: absolute;
      top: 19px;
      right: 10px;
      height: 40px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        top: 5px;
        height: 25px;
      }
      .scc-place {
       margin-right: 0px;
       svg {
          width: 30px;
          height: 30px;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            width: 25px;
            height: 25px;
          }
        }
        &.twit-icon {
          margin-right: 8px;
        }
      }
    }
  .company-name{
    color: ${primaryHeadingColor};
    font-weight:${wMBold};
    font-family: ${secondaryFont};
    font-size: 34px;
    line-height:36px;
    text-align: center;
    margin: 0px 0 20px 0;
    letter-spacing: -0.85px;
    padding: 0px 30px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 24px;
    line-height: 26px;
    margin: 0px 0 20px 0;
    }
    @media all and (max-width: ${minWidthApp}){
      padding: 0px;
    }
    @media all and (max-width: ${maxTablet}) {
     word-break: break-word;
    }
  }
  .founded-area {
    margin-left: -40px;
    row-gap: 8px
  }
  .head {
    display: flex;
    justify-content: flex-end;
  }
  .col-div-height {
    max-height: 27px;
    @media all and (max-width: ${maxWidth}) ,${retina} {
      max-height: 23px;
    }
  }
  .item-label{
    &.fiscal-year {
      width: unset;
    }
    color:${primaryHeadingColor};
    font-size: 18px;
    font-weight: ${wMedium};
    font-family: ${primaryFont};
    text-align: right;
    width:80px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 14px;
    }
  }
  .item-value{
    font-family: ${primaryFont};
     color:${primaryHeadingColor};
     font-weight:${wLight};
     color: ${primaryHeadingColor};
     font-size: 18px;
     margin-left: 16px;
     @media all and (max-width: ${maxWidth}) , ${retina} {
       font-size: 14px;
     }
     &.is-pointing{
       cursor: pointer;
     }
    &.green-value{
      color: ${primaryColor};
    }
  }
  .recommendation{
    margin: 18px 0 20px 0;
    color: #B6B6B6;
    text-align: center;
    font-size: 14px;
    font-weight: ${wLight};
    font-family: ${primaryFont};
    font-style: italic;
    @media all and (max-width: ${maxWidth}), ${retina} {
      margin: 30px 0 20px 0;
    }
  }
  .mt-2 {
    margin-top: 20px;
  }
  .company-holo-placeholder {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
`;
const ToolTipWrapper = styled.div`
  .tooltip-text {
    color: black;
    font-family: ${primaryFont};
    font-size: 13px;
    line-height: 13px;
    font-weight: ${wLight};
    .bold {
      font-weight: 900;
      margin-right: 5px;
    }
    .light {
      margin-left:5px;
    }
  }
  .ant-tooltip-content {
      border-radius: 10px;
   }
  .ant-tooltip-inner {
    border-radius: 10px;
    color: black;
    padding: 10px 20px;
    font-family: ${primaryFont};
    font-size: 13px;
    line-height: 20px;
    font-weight: ${wLight};
   }
`;
const CompanyInfo = function CompanyInfo(props: Props) {
  const {
    companyProfile, isCluster, companyIndex, totalCompanies,
  } = props;

  const dispatch = useDispatch();
  const previousCompany = usePrevious(companyProfile);
  const navigate = useNavigate();
  const isMob = IsMobile();
  const host = window.location.href;
  const [fields, setFields] = useState<PropFeildState>({
    companyName: '',
    year: '',
    ceo: null,
    industry: '',
    count: 0,
    logo: '',
    persona: [],
    industryId: 0,
    websiteLink: '',
    exchange: '',
    companyFiscalYear: '',
    linkedinLink: '',
    twitterLink: '',
  });

  const {
    linkedinLink,
    twitterLink,
    industryId,
    websiteLink,
  } = fields;

  useEffect(() => {
    if (
      companyProfile?.companyId !== previousCompany?.companyId
    ) {
      const fieldsCopy = { ...fields };
      const {
        companyName: companyNameFromProfile,
        linkedinLink: linkedinLinkFromProfile,
        twitterLink: twitterLinkFromProfile,
        companyIndustry,
        companyLogo,
        userCompanyFollowers,
        companyPersonality,
        companyCeo,
        companyFounded,
        companyIndustryId,
        companyStockExchange,
        fiscalYear,
        companyDomain,
      } = companyProfile;
      fieldsCopy.companyName = companyNameFromProfile;
      fieldsCopy.linkedinLink = linkedinLinkFromProfile;
      fieldsCopy.twitterLink = twitterLinkFromProfile;
      fieldsCopy.industry = companyIndustry;
      fieldsCopy.logo = companyLogo;
      fieldsCopy.count = userCompanyFollowers;
      fieldsCopy.persona = companyPersonality;
      fieldsCopy.ceo = companyCeo;
      fieldsCopy.year = companyFounded;
      fieldsCopy.industryId = companyIndustryId;
      fieldsCopy.websiteLink = companyDomain;
      fieldsCopy.exchange = companyStockExchange;
      fieldsCopy.companyFiscalYear = fiscalYear;
      setFields(fieldsCopy);
    }
  }, [companyProfile]);

  const handleWebsiteClick = () => {
    if (websiteLink.length) {
      window.open(companyProfile.companyWebsite.slice(0, 4) === 'http' ? companyProfile.companyWebsite : `https://${companyProfile.companyWebsite}`);
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('company_websiteLink_clicked', 0, {
          company_id: companyProfile.companyId,
          company_name: companyProfile.companyName,
        }),
      ));
    }
  };

  const handleLinkedInClick = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('linkedin_companyprofile', getCurrentTime(), {
        company_id: companyProfile.companyId,
        company_name: companyProfile.companyName,
        host
      }),
    ));
  };

  return (
    <Wrapper className="company-info-wrapper">
      {isCluster && companyIndex > 0 && totalCompanies > 0 ? (
        <span className="company-card-counter">
          {`${companyIndex}/${totalCompanies}`}
        </span>
      ) : null}
      {!isMob ? (
        <div className={classNames('social-icons-wrap', { privateCompanySocials: isAPrivateCompany(companyProfile) })}>
          {
            linkedinLink?.length ? (
              <a key={linkedinLink} href={linkedinLink} target="_blank" className="scc-place" rel="noreferrer" onClick={handleLinkedInClick}>
                <LinkedInIcon />
              </a>
            ) : null
          }
          {
            twitterLink?.length ? (
              <a key={twitterLink} href={twitterLink} target="_blank" className="scc-place twit-icon" rel="noreferrer">
                <TwitterIcon />
              </a>
            ) : null
          }
        </div>
      ) : null}
      {
        companyProfile.companyLogo?.length ? (
          <div className="company-holo-placeholder">
            <CompanyWidgetWithHolo
              logo={companyProfile.companyLogo}
              ringPaddingSm="3px"
              diameter="210px"
              diameterSm="240px"
              diameterL="300px"
              ringPosition="center center"
              ringSize="50% 50%"
              companyHoloColors={companyProfile.companyPersonality}
              wrapperColor={companyColorParser(companyProfile.companyPersonality)}
            />
          </div>
        ) : null
      }
      <h1 className="company-name">{companyProfile.companyName?.length ? companyProfile.companyName : 'N/A'}</h1>
      <Row className="founded-area">
        <Col span={12} className="head"><span className="item-label">Founded:</span></Col>
        <Col span={12}><span className="item-value text-truncate-one-line">{companyProfile.companyFounded?.length ? companyProfile.companyFounded : 'N/A'}</span></Col>

        <Col span={12} className="head">
          <span className="item-label">CEO:</span>
        </Col>
        <Col span={12}>
          <span
            className={`item-value ${companyProfile.companyCeo?.personId ? 'is-pointing' : ''} green-value text-truncate-one-line`}
            onClick={() => {
              if (companyProfile.companyCeo?.personId) navigate(`${PERSONALITY_INSIGHTS_ROUTE}${companyProfile.companyCeo?.personId}`);
            }}
            onKeyPress={() => {
              if (companyProfile.companyCeo?.personId) navigate(`${PERSONALITY_INSIGHTS_ROUTE}${companyProfile.companyCeo?.personId}`);
            }}
            role="button"
            aria-label={companyProfile.companyCeo?.personName?.length ? companyProfile.companyCeo.personName : 'N/A'}
            tabIndex={0}
          >
            {companyProfile.companyCeo?.personName?.length ? companyProfile.companyCeo.personName : 'N/A'}
          </span>

        </Col>

        <Col span={12} className="head"><span className="item-label">Industry:</span></Col>
        <Col span={12}>
          <ToolTipWrapper>
            <Tooltip
              placement="bottomLeft"
              title={companyProfile.companyIndustry?.length ? companyProfile.companyIndustry : 'N/A'}
              getPopupContainer={(e: HTMLElement) => e}
              className="tooltip"
              color="#fff"
              autoAdjustOverflow={false}
              arrow={false}
            >
              <span
                className={`item-value ${industryId ? 'is-pointing' : ''} green-value text-truncate-one-line`}
                onClick={() => { if (industryId) navigate(`${INDUSTRY_NEWS_ROUTE}${industryId}`); }}
                onKeyPress={() => { if (industryId) navigate(`${INDUSTRY_NEWS_ROUTE}${industryId}`); }}
                role="button"
                aria-label={companyProfile.companyIndustry?.length ? companyProfile.companyIndustry : 'N/A'}
                tabIndex={0}
              >
                {companyProfile.companyIndustry?.length ? companyProfile.companyIndustry : 'N/A'}
              </span>
            </Tooltip>
          </ToolTipWrapper>

        </Col>
        <Col span={12} className="head col-div-height"><span className="item-label">Website:</span></Col>
        <Col span={12} className="col-div-height">
          <ToolTipWrapper>
            <Tooltip
              placement="bottomLeft"
              title={companyProfile.companyDomain}
              getPopupContainer={(e: HTMLElement) => e}
              className="tooltip"
              color="#fff"
              autoAdjustOverflow={false}
              arrow={false}
            >

              <span
                className={`item-value ${companyProfile.companyDomain ? 'is-pointing' : ''} green-value text-truncate line-block w-100 ${translateSkipAreas}`}
                onClick={handleWebsiteClick}
                onKeyPress={handleWebsiteClick}
                role="button"
                aria-label={companyProfile.companyDomain?.length ? companyProfile.companyDomain : 'N/A'}
                tabIndex={0}
              >
                {companyProfile.companyDomain?.length ? companyProfile.companyDomain : 'N/A'}
              </span>
            </Tooltip>
          </ToolTipWrapper>
        </Col>
        {isAPrivateCompany(companyProfile) ? null : (
          <>
            <Col span={12} className="head"><span className="item-label">Exchange:</span></Col>
            <Col span={12}><span className="item-value text-truncate-one-line">{companyProfile.companyStockExchange?.length ? companyProfile.companyStockExchange : 'N/A'}</span></Col>
          </>
        )}
        {isAPrivateCompany(companyProfile) ? null : (
          <>
            <Col span={12} className="head"><span className="item-label fiscal-year">Fiscal Year:</span></Col>
            <Col span={12}><span className="item-value text-truncate-one-line">{companyProfile.fiscalYear?.length ? companyProfile.fiscalYear : 'N/A'}</span></Col>
          </>
        )}
      </Row>
      <div className="d-flex justify-content-center mt-2 bottom-btn-div">
        <CompanyFollowUnFollowButton companyData={companyProfile} />
        <div>
          <DrawerPeopleMoveReason
            isCompanyNotes
            companyId={companyProfile.companyId}
          />
        </div>
      </div>
    </Wrapper>
  );
};

CompanyInfo.defaultProps = defaultProps;

export default CompanyInfo;
